<template>
  <PrivacyPage></PrivacyPage>
</template>

<script setup>
useHead({
  title: 'Proxify privacy policy',
  meta: [
    {
      hid: 'og:title',
      property: 'og:title',
      content: 'Proxify privacy policy',
    },
    {
      hid: 'og:description',
      name: 'description',
      property: 'og:description',
      content:
        'This privacy policy explains how we collect, use, share and transfer your personal data when you use the services provided on Proxify.',
    },
  ],
});
</script>
